import React from 'react'

const MoneyIcon: React.FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="money">
        <path
          id="Vector"
          d="M7.99996 8.33325C6.71129 8.33325 5.66663 9.37792 5.66663 10.6666C5.66663 11.9553 6.71129 12.9999 7.99996 12.9999C9.28863 12.9999 10.3333 11.9553 10.3333 10.6666C10.3333 9.37792 9.28863 8.33325 7.99996 8.33325ZM6.99996 10.6666C6.99996 10.1143 7.44769 9.66659 7.99996 9.66659C8.55223 9.66659 8.99996 10.1143 8.99996 10.6666C8.99996 11.2189 8.55223 11.6666 7.99996 11.6666C7.44769 11.6666 6.99996 11.2189 6.99996 10.6666Z"
          fill="#EDEBF7"
        />
        <path
          id="Vector_2"
          d="M11.6841 3.41075L9.56493 0.439697L1.77231 6.66447L1.33975 6.66042L1.33969 6.66675H1V14.6667H15V6.66675H14.3589L13.0827 2.93406L11.6841 3.41075ZM12.9498 6.66675H6.26435L11.2438 4.96949L12.2584 4.64475L12.9498 6.66675ZM10.3667 3.85981L5.22633 5.6119L9.29707 2.36021L10.3667 3.85981ZM2.33333 12.1125V9.21961C2.90161 9.01875 3.35201 8.56835 3.55286 8.00008H12.4468C12.6477 8.56855 13.0982 9.01908 13.6667 9.21995V12.1139C13.0984 12.3147 12.648 12.7651 12.4471 13.3334H3.55425C3.35328 12.7644 2.90233 12.3135 2.33333 12.1125Z"
          fill="#EDEBF7"
        />
      </g>
    </svg>
  )
}

export default MoneyIcon
